import {
  AccountCircleIcon,
  ChevronRightIcon,
  DescriptionOutlinedIcon,
  LogoutIcon,
  OpenInNewIcon,
  TranslateIcon,
} from 'common/icons';
import { useTranslation } from 'react-i18next';
import { NeutralColors, RedColors } from 'theme';

import * as Styled from '../../sider-navbar-mobile.style';
import { useProfileDrawer } from './profile-drawer.hook';
import { ProfileDrawerItem } from './profile-drawer-item/profile-drawer-item.component';
import { ProfileDrawerSelectLanguage } from './profile-drawer-select-language/profile-drawer-select-language.component';
import { ProfileDrawerTitle } from './profile-drawer-title/profile-drawer-title.component';

interface ProfileDrawerProps {
  open: boolean;
  onClose: () => void;
}

const ProfileDrawer = ({ open, onClose }: ProfileDrawerProps) => {
  const { t, i18n } = useTranslation();
  const {
    handleClickOnEditProfile,
    handleClickLegalDocuments,
    handleClickOnLogout,
    handleClickOnSelectLanguage,
    handleCloseSelectLanguageDrawer,
    isOpenSelectLanguegeDrawer,
  } = useProfileDrawer();

  return (
    <Styled.DrawerLayout open={open} width="100vw" closable={false}>
      <ProfileDrawerSelectLanguage
        isOpen={isOpenSelectLanguegeDrawer}
        onClose={handleCloseSelectLanguageDrawer}
      />
      <ProfileDrawerTitle title={t('profile.drawer.title')} onBack={onClose} />
      <ProfileDrawerItem
        onClick={handleClickOnEditProfile}
        icon={<AccountCircleIcon />}
        suffixIcon={<OpenInNewIcon />}
        title={t('profile.drawer.edit_profile.title')}
        description={t('profile.drawer.edit_profile.description') ?? ''}
        color={NeutralColors[100]}
      />
      <ProfileDrawerItem
        onClick={handleClickOnSelectLanguage}
        icon={<TranslateIcon />}
        suffixIcon={<ChevronRightIcon />}
        title={t('profile.drawer.select_language.title')}
        description={t(`profile.drawer.languages.${i18n.language}`) ?? ''}
        color={NeutralColors[100]}
      />
      <ProfileDrawerItem
        onClick={handleClickLegalDocuments}
        icon={<DescriptionOutlinedIcon />}
        suffixIcon={<OpenInNewIcon />}
        title={t('profile.drawer.legal_documents.title')}
        description={t('profile.drawer.legal_documents.description') ?? ''}
        color={NeutralColors[100]}
      />
      <ProfileDrawerItem
        onClick={handleClickOnLogout}
        icon={<LogoutIcon />}
        title={t('profile.drawer.logout.title')}
        color={RedColors[60]}
      />
    </Styled.DrawerLayout>
  );
};

export { ProfileDrawer };
